import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchStrategyEvaluations } from './strategyEvaluationAPI';

const initialState = {
  data: [],
  status: 'idle',
  error: null,
};

export const fetchStrategyEvaluationDataWithFilters = createAsyncThunk(
  'strategyEvaluation/fetchStrategyEvaluationDataWithFilters',
  async ({ filter = {}, options = {} }) => {
    const response = await fetchStrategyEvaluations({ filter, options });
    return response.data;
  }
);

export const strategyEvaluationSlice = createSlice({
  name: 'strategyEvaluation',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStrategyEvaluationDataWithFilters.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchStrategyEvaluationDataWithFilters.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      })
      .addCase(fetchStrategyEvaluationDataWithFilters.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export const selectStrategyEvaluationData = (state) => state.strategyEvaluation.data;
export const selectStrategyEvaluationStatus = (state) => state.strategyEvaluation.status;
export const selectStrategyEvaluationError = (state) => state.strategyEvaluation.error;

export default strategyEvaluationSlice.reducer;
